import { useSearchParams } from 'react-router-dom';

import { AddCustomerQuote } from 'iframe/components';
import { IframePageLayout } from 'iframe/pages';
import { IQuickQuoteContactPreload } from 'quotes/components';
import { QuoteEntityType } from 'quotes/enums';

const TRUTHY_FLAG_VALUES = ['1', 'true'];

export const AddCustomerQuotePage = () => {
  const [searchParams] = useSearchParams();

  const entityType = (searchParams.get('entityType') as QuoteEntityType) || QuoteEntityType.QUOTE;

  const contactEmail = searchParams.get('contactEmail');
  const contactGroupId = searchParams.get('contactGroupId');

  const preloadContact: IQuickQuoteContactPreload = {
    email: contactEmail || undefined,
    contactGroupId: contactGroupId ? Number(contactGroupId) : undefined,
  };

  const enableProspectQuickQuote = TRUTHY_FLAG_VALUES.includes(
    searchParams.get('prospectQuickQuote') || ''
  );

  return (
    <IframePageLayout>
      <AddCustomerQuote
        entityType={entityType}
        preloadContact={preloadContact}
        enableProspectQuickQuote={enableProspectQuickQuote}
      />
    </IframePageLayout>
  );
};
